import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseDtoSearchService, IBaseDto } from './base-dto.service';
import {
    ContactClient,
    SearchContactsBasicDataParameters,
    SearchContactsBasicDataResultDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ReportingContactService extends BaseDtoSearchService {
    constructor(protected client: ContactClient) {
        super();
    }

    async search(filterText: string): Promise<IBaseDto[]> {
        const response = await lastValueFrom(
            this.client.contactSearchBasicData({ filterText } as SearchContactsBasicDataParameters)
        );
        return response.map((contact) => ({
            id: contact.id,
            name: contact.fullName
        }));
    }

    override getById(id: number): Promise<IBaseDto> {
        throw new Error('Method not implemented.');
    }

    async getByIds(contactIds: number[]): Promise<SearchContactsBasicDataResultDto[]> {
        return await lastValueFrom(
            this.client.contactSearchBasicData({ contactIds } as SearchContactsBasicDataParameters)
        );
    }
}
